export default {
  rr360: {
    unathorized: false,
    isMobile: true,
    ads: {type: null, showFull: false, showMobile: true},
    brand: null,
    accountId: '',
    eventId: '',
    bib: '',
    runnerResult: {},
    races: [],
    raceDetail: {},
    leadersMen: [],
    leadersWomen: [],
    favorites: [],
    results: null,
    resultsTotal: null,
    resultsPage: 0,
    searchResults: null,
    collectiveSearchResults: null,
    searchResultsTotal: null,
    searchResultsPage: 0,
    search: '',
    div: 'ALL',
    singleEvent: false,
    theme: {primaryColor: '#DE181F', secondaryColor: '#ffffff', logo: 'https://admin.cdn.raceresults360.com/rr360logo.png', headerHeight: 30}
  }
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js